import {Icon} from "@client/components/Icon";
import {TouchHandler} from "@client/components/TouchHandler";
import {Icon as IconLiterals} from "@client/constants";
import {Locator} from "@client/gotterdammerung";
import {classes} from "@client/utils";
import * as React from "react";

const styles = {
    tab: "flex-1",
    tabContent:
        "border-b border-[#D8D8D8] py-[9px] pb-2 text-xs font-medium min-h-8 flex items-center justify-center",
    selected: "border-b-[#4FAFE5] text-[#4FAFE5] border-b-4 pb-[5px]",
    hasError: "text-[#E62020] border-b-[#E62020]",
} as const;

interface Props {
    title: string;
    link: (() => void) | Locator;
    icon: IconLiterals;
    isSelected: boolean;
    primaryIsSelected: boolean;
    hasErrors: boolean;
    showIcon: boolean;
}

export const Tab = (props: Props) => {
    const tabClasses = classes({
        [styles.tabContent]: true,
        [styles.selected]: props.isSelected,
        [styles.hasError]: props.hasErrors,
    });

    const providedLink = props.link;

    const {link, onClick} = {
        link: providedLink,
        onClick: undefined,
    };

    return (
        <li className={styles.tab}>
            <TouchHandler role="tab" disableBackground link={link} onClick={onClick}>
                <div className={tabClasses}>
                    {props.showIcon === true ? (
                        <Icon icon={props.icon}>{props.title}</Icon>
                    ) : (
                        props.title
                    )}
                </div>
            </TouchHandler>
        </li>
    );
};
